import * as React from "react";

const ProdPadIcon = (props: { width?: number; height?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
    width={props.width ?? 25}
    height={props.height ?? 25}
  >
    <path
      fill="#25A7D9"
      d="M51.9,24.7c0-4.7-0.6-9.3-1.6-14c-1-4.6-4.6-8.1-9.2-9C36,0.6,30.9,0,25.9,0c-5,0-10,0.6-15.1,1.6
      c-4.6,0.9-8.1,4.4-9.2,9c-1,5-1.6,10-1.6,15.1c0,1.3,0,2.5,0.1,3.8c4.9,0.3,14-1.8,22.7-8.3c-4.6-0.9-6.2-2.1-6.2-3.4
      c-0.1-0.9,1.2-1.6,3.7-2.4L38.7,12c-1,10.9-1.8,17.1-1.9,18.6c-0.3,2.2-0.9,4.1-2.2,4c-1.3-0.3-2.8-1.9-3.8-6.1
      c-5.9,9.8-6.6,18.6-6.4,23.3V52h1.8c5,0,10.2-0.6,15.2-1.6c4.6-1,8.1-4.6,9-9c1-4.7,1.5-9.5,1.6-14.3v-2.4L51.9,24.7z"
    />
    <path
      fill="#25A7D9"
      d="M13.9,51c0.3-9.9,2.2-14.5,2.5-15.2C15.7,36,10.9,37.7,1.2,38c0.1,1.2,0.4,2.2,0.6,3.4c1,4.6,4.4,8,9,9
      C11.8,50.7,12.9,50.8,13.9,51z"
    />
  </svg>
);

export default ProdPadIcon;
